<h2 mat-dialog-title translate>Report Snapshots</h2>

<!-- <div style="padding-top:10px;">
        <span style="padding-left:10px;">Report Folder&nbsp;</span>
        <select ng-options="Folder as Folder.Name for Folder in reportFolders|orderBy: 'Name'" ng-model="SelectedSnapshotFolder" style="width:250px;" ng-change="selectedFolderChanged()">
            <option value="">(All)</option>
        </select>
        <span style="padding-left:60px;">Report&nbsp;</span>
        <select ng-options="Report as Report.Name for Report in allReports|reportsFilter: SelectedSnapshotFolder|orderBy: 'Name'" ng-model="SelectedSnapshotReport" style="width:350px;" >
            <option value="">(All)</option>
        </select>
    </div> -->

    <!-- [ngModel]="SelectedSnapshotFolder"-->

<mat-dialog-content>

    <table class="table" style="width:100%;">
        <tr>
            <td>
                <tyl-form-field 
                    label="Report Folder">
                    <mat-select id="snapshotReportFolderID" 
                        name="snapshotReportFolder"
                        [(ngModel)]="selectedFolderName"       
                        (ngModelChange)= "selectedFolderChanged()"
                    >
                        <mat-option 
                            *ngFor="let Folder of reportFolders" 
                            [value]="Folder.Name">{{Folder.Name}}
                        </mat-option>
                    </mat-select>
                </tyl-form-field>
            </td>
            <td>
                <tyl-form-field 
                    label="Report">
                    <mat-select id="snapshotReportID" 
                        name="snapshotReport"
                        [(ngModel)]="selectedReport"
                    >
                        <mat-option 
                            *ngFor="let Report of sortedReports | reportInFolderFilter: selectedFolderName" 
                            [value]="Report">{{Report.Name}} 
                        </mat-option>
                    </mat-select>
                </tyl-form-field>       
                <!-- *ngFor="let Report of allReports | reportInFolderFilter: selectedFolderName" -->    
            </td>
        </tr> 
    </table>


    <table class="table" style="width:100%;">
        <tr>
            <!-- <th style="padding-left:5px; width:15px;">
                <tyl-checkbox 
                    [(checked)]="snapshotCheckAll"
                    (change)="snapshotCheckAllClick($event)"
                    id="snapshotCheckAll_ID"
                    name="snapshotCheckAll">
                </tyl-checkbox>
            </th> -->
            <th style="width:100px;padding-left:10px;">Folder</th>
            <th style="width:200px;padding-left:20px;">Report</th>
            <th style="width:120px;padding-left:20px;">Snapshot Taken</th>
            <th style="width:150px;padding-left:20px;">Error</th>
            <th style="width:50px;padding-right:10px;">Actions</th>
        </tr>
        <!-- <tr style="line-height:25px;" *ngFor="let Snapshot of allSnapshots | snapshotInFolderFilter: selectedFolderName "> -->
        <tr style="line-height:25px;" *ngFor="let Snapshot of allSnapshots | snapshotInFolderFilter: selectedFolderName:selectedReport.Name">
            
        
                
            <!-- <td style="padding-left:5px;">
                <tyl-checkbox 
                    [(checked)]="Snapshot.IsSelected" 
                    (change) = "snapshotCheckClick(Snapshot)"
                    id="snapshotCheck_ID + {{Snapshot.AutoRunReportSnapshots_ID}}"
                    name="snapshotCheck + {{Snapshot.AutoRunReportSnapshots_ID}}">
                </tyl-checkbox>
            </td> -->
            <td style="white-space:nowrap;padding-left:10px;">{{Snapshot.FolderName}}</td>
            <td style="white-space:nowrap;padding-left:25px;">{{Snapshot.ReportName}}</td>
            <td style="white-space:nowrap;padding-left:25px;"><a class="link" (click)="getReportSnapshot(Snapshot)">{{Snapshot.TimeStamp|date:'MM/dd/yy
                    HH:mm a'}}</a></td>
            <td style="line-height:normal;padding-left:25px;">{{Snapshot.Error}}</td>
            <td style="padding-right:15px; padding-left:5px;">
                <a style="font-size:10pt;cursor:pointer;" (click)="snapshotDeleteClick(Snapshot)">
                    <span>Delete</span>
                </a>
            </td>
        </tr>
    </table>

</mat-dialog-content>


<!-- Dialog Footer -->
<mat-dialog-actions>
    <!-- <div class='flex-footer-left'>
            <tyl-button image="trash.png" translate label="Delete Selected Snapshots" (clickEvent)="deleteSelectedSnapshotsClick()"></tyl-button>
    </div> -->
    <div class='flex-footer-right'>
        <!-- <tyl-button image="delete.png" translate label="Delete Selected Snapshots" (clickEvent)="deleteSelectedSnapshotsClick()"></tyl-button> -->
        <tyl-button image="cancel.png" translate label="Close" (clickEvent)="closeClick()"></tyl-button>
        <!-- style="float:right; color: white;" -->
    </div>
</mat-dialog-actions>